<template>
  <div v-if="showHead">
    <div class="bar-list d-flex a-center">
      <div v-for="(item, index) in routes" class="bar-item" :class="{
      active: path == item.path || path == item.redirect
    }" :key="index">
        <div v-if="item.path === '/private'">
          <el-badge :value="unReadNums" :max="99" :hidden="unReadNums==0">
            <router-link :to="item.path" class="link-txt">{{item.meta.title}}</router-link>
          </el-badge>
        </div>
        <div v-else-if="item.path === '/comment'">
          <el-badge :value="comment_nums" :max="99" :hidden="comment_nums==0">
            <router-link :to="item.path" class="link-txt">{{item.meta.title}}</router-link>
          </el-badge>
        </div>
        <router-link v-else :to="item.path" class="link-txt">{{item.meta.title}}</router-link>
      </div>
    </div>
    <div style="height: 54px"></div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'HeadBar',
  computed: {
    ...mapGetters(['permission_routes']),
    routes() {
      const permission_routes = this.permission_routes
      console.log(' permission_routes', permission_routes)
      const routes = []
      for (const m in permission_routes) {
        console.log('!permission_routes[m].hidden', !permission_routes[m].hidden)
        if (!permission_routes[m].hidden) {
          routes.push(permission_routes[m])
        }
      }
      console.log('routes', routes)
      return routes
    },
    path() {
      console.log('this.$route', this.$route)
      return this.$route.path
    },
    showHead() {
      return this.$route.meta.showHead === false ? false : true
    }
  },
  data() {
    return {
      unReadNums: 0,
      comment_nums: 0
    }
  },
  watch: {
    $route(to) {
      console.log('to', to)
      this.getNums()
    }
  },
  mounted() {
    this.getNums()
    console.log('permission_routes', this.permission_routes)
    this.$EventBus.$on('addUnReadNums', () => {
      this.unReadNums++
      // const audio = new Audio('/new_message.mp3')
      // audio.play()
    })
    this.$EventBus.$on('updateUnReadNums', (num) => {
      let unReadNums = this.unReadNums
      unReadNums += num
      if (this.unReadNums<0) {
        this.unReadNums = 0
      } else {
        this.unReadNums = unReadNums
      }
    })
    this.$EventBus.$on('updateNums', () => {
      this.getNums()
    })
  },
  methods:{
    getNums() {
      this.$axios.post('client/cir-circle/push-count', {}).then(res => {
        console.log('push-count', res)
        if (res.code == 0) {
          const { unread_nums, unanswered, uncomment_nums } = res.data
          this.unReadNums = parseInt(unread_nums)
          const comment_nums = parseInt(unanswered) + parseInt(uncomment_nums)
          this.comment_nums = comment_nums
        } else {
          this.$notify.warning(res.message || '网络错误')
        }
      })
    }
  }
}
</script>

<style scoped>
.bar-list{
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  z-index: 99;
  margin: 0 auto;
  padding-top: 12px;
  box-sizing: border-box;
  width: 900px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  height: 54px;
  box-sizing: border-box;
  background-color: #FAF5F5;
}
.bar-item{
  position: relative;
  color: #333333;
  font-size: 16px;
  width: 112px;
  text-align: center;
  line-height: 41px;
  cursor: pointer;
}
.bar-item.active{
  color: #A60200;
}
.bar-item.active:after{
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 3px;
  background-color: #A60200;
  font-weight: bold;
}
.link-txt{
  color: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
</style>
